"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/col/style");
var _col = _interopRequireDefault(require("antd/lib/col"));
require("antd/lib/row/style");
var _row = _interopRequireDefault(require("antd/lib/row"));
require("antd/lib/button/style");
var _button = _interopRequireDefault(require("antd/lib/button"));
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var SuccessFooter = function SuccessFooter(_ref) {
  var onCancel = _ref.onCancel,
    groupId = _ref.groupId;
  var history = (0, _reactRouterDom.useHistory)();
  var onSeeGroup = (0, _react.useCallback)(function () {
    history.push("/groups/".concat(groupId));
  }, [groupId, history]);
  return /*#__PURE__*/_react.default.createElement(_row.default, null, /*#__PURE__*/_react.default.createElement(_col.default, {
    span: 12
  }, /*#__PURE__*/_react.default.createElement(_row.default, {
    type: "flex",
    justify: "start"
  }, /*#__PURE__*/_react.default.createElement(_button.default, {
    type: "link",
    onClick: onSeeGroup
  }, "See group"))), /*#__PURE__*/_react.default.createElement(_col.default, {
    span: 12
  }, /*#__PURE__*/_react.default.createElement(_row.default, {
    type: "flex",
    justify: "end"
  }, /*#__PURE__*/_react.default.createElement(_button.default, {
    type: "primary",
    onClick: onCancel
  }, "OK"))));
};
var _default = SuccessFooter;
exports.default = _default;